import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

export const KpiCard = ({
    label,
    value,
    sub,
    icon: Icon,
    tone = "primary",
    delta,
    index = 0,
    className,
}) => {
    const toneBg = {
        primary: "bg-primary/10 text-primary",
        accent: "bg-accent/10 text-accent",
        success: "bg-success/10 text-success",
        warning: "bg-warning/14 text-warning",
        destructive: "bg-destructive/10 text-destructive",
    }[tone];

    return (
        <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
        >
            <Card
                className={cn(
                    "group relative h-full overflow-hidden border-border/70 bg-card p-5 shadow-card transition-shadow duration-300 hover:shadow-lift",
                    className,
                )}
            >
                <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                            {label}
                        </p>
                        <p className="mt-2 text-3xl font-semibold tracking-tight tabular text-foreground">
                            {value}
                        </p>
                        {sub && (
                            <p className="mt-1 text-sm text-muted-foreground">{sub}</p>
                        )}
                    </div>
                    {Icon && (
                        <span
                            className={cn(
                                "flex h-10 w-10 shrink-0 items-center justify-center rounded-xl",
                                toneBg,
                            )}
                        >
                            <Icon className="h-5 w-5" strokeWidth={2} />
                        </span>
                    )}
                </div>
                {delta}
            </Card>
        </motion.div>
    );
};
